import React, { useEffect } from "react";
import MarketingHeader from "./MarketingHeader";
import FinalCta from "./FinalCta";
import ScrollProgress from "./ScrollProgress";
import AmbientBlobs from "./AmbientBlobs";
import SiteFooter from "./SiteFooter";
import ScrollToTop from "../../components/ScrollToTop";
import "../styles.css";

const MarketingLayout = ({ children, showFinalCta = true, variant }) => {
  useEffect(() => {
    document.body.classList.add("marketing-page");
    const variantClass = variant ? `is-${variant}` : null;
    if (variantClass) document.body.classList.add(variantClass);
    return () => {
      document.body.classList.remove("marketing-page");
      if (variantClass) document.body.classList.remove(variantClass);
    };
  }, [variant]);

  useEffect(() => {
    // Use a data-* attribute instead of a className. React's reconciliation
    // replaces className on every re-render (e.g. when an FAQ item toggles
    // its own open state), which would wipe out a JS-added `.visible` class
    // and make the element disappear. React leaves unknown data-* attributes
    // alone, so this survives re-renders.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute("data-mk-visible", "true");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".mk-reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [children]);

  return (
    <>
      <ScrollToTop />
      <ScrollProgress />
      <AmbientBlobs />
      <div className="mk-page">
        <MarketingHeader />
        {children}
        {showFinalCta && <FinalCta />}
        <SiteFooter />
      </div>
    </>
  );
};

export default MarketingLayout;
